import React, { useEffect, useState } from 'react';
import { Form, FormGroup, ControlLabel, Alert, Modal, Button, Uploader } from 'rsuite';
import { alertInfo } from '../../helpers';
import { disableInput } from '../../helpers/styless';
import { TextField } from '../../helpers/rsuite';
import { cuotitasStoreService } from '../../services';
import createFormData from '../../helpers/UpdateCommerceMultipart';

const defaultStore = {
    requestId: '',
    name: '',
    cuit: '',
    rubro: '',
    addressStreet: '',
    addressNumber: '',
    postalCode: '',
    province: '',
    county: '',
    email: '',
    telephone: '',
    filesList: [],
    status: ''
};

export default function ViewCommerceDialog ({ show, onHide, id }) {
    const [uploadDisabled, setUploadDisabled] = useState(false);
    const [showAlert, setShowAlert] = useState(true);
    const [store, setStore] = useState(defaultStore);
    const [change, setChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [newFilesToUpload, setNewFilesToUpload] = useState([]);

    const getStore = () => {
        setIsLoading(true);
        cuotitasStoreService
            .getById(id)
            .then(store => {
                setStore(
                    {
                        requestId: store?.requests[0]?.id_request || '',
                        name: store?.name || '',
                        cuit: store?.cuit || '',
                        addressStreet: store?.addresses[0]?.street || '',
                        addressNumber: store?.addresses[0]?.number || '',
                        email: store?.email || '',
                        telephone: store?.telephone || '',
                        rubro: store?.category || '',
                        status: store?.id_store_status || '',
                        postalCode: store?.addresses[0]?.postal_code || '',
                        province: store?.addresses[0]?.province || '',
                        county: store?.addresses[0]?.county || '',
                        floor: store?.addresses[0]?.metadata?.floor || '',
                        filesList: getFiles(store?.files) || [],
                    }
                );
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => setIsLoading(false));
    };

    const getFiles = (files) => {
        return files.map(file => {
            return {
                name: file.metadata.filename,
                fileKey: file.id,
                url: file.description
            };
        });
    };

    const getFilesInDB = (store) => {
        return store.filesList
            .filter(file => !file.blobFile)
            .map(file => {
                return { id: file.fileKey };
            });
    };

    const updateStore = (store, id, newFilesToUpload) => {
        const filesStoredInDB = getFilesInDB(store);
        const multiPartData = createFormData(store, newFilesToUpload, filesStoredInDB);
        cuotitasStoreService
            .updateStore(multiPartData, id)
            .then(result => {
                onHide();
                Alert.success('El comercio se actualizó correctamente.', 5000);
                return result;
            })
            .catch(e => {
                console.error(e);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                onHide();
                setIsLoading(false);
            });
    };

    const handleDownload = file => {
        const newWindow = window.open(file.url, '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.opener = null;
        }
    };

    const handleUpDateCommerce = () => {
        !change ? onHide() : updateStore(store, id, newFilesToUpload);
        setChange(false);
    };

    const handleChange = files => {
        if (files.length > 10) {
            alertInfo('El limite máximo de archivos es 10', showAlert, setShowAlert);
            return false;
        }
        setUploadDisabled(files.length >= 10);
        setChange(true);
        const newFiles = files.filter(file => file.blobFile);
        setStore({ ...store, filesList: files });
        setNewFilesToUpload(newFiles);
    };

    const handleRemove = file => {
        const files = store.filesList.filter(item => file.name !== item.name);
        setChange(true);
        setStore({ ...store, filesList: files });
    };
    useEffect(() => {
        getStore();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (

        <Modal
            show={show && !isLoading}
            onHide={onHide}
            className={`${show ? 'show in' : ''} modal-responsive`}
            aria-labelledby='user-create-modal'
            size='lg'
            keyboard={false}
        >
            <Modal.Header closeButton >
                <Modal.Title id='user-create-modal '>
                    <div className='d-flex justify-content-start'>
                        <span>Comercio # {id}</span>
                    </div>
                </Modal.Title>
            </Modal.Header >
            <Modal.Body className='h-75' style={{ overFlow: 'hidden! important' }}>
                {!isLoading && (
                    <div className='row justify-content-center'>
                        <div className='col-md-10'>
                            <Form
                                fluid
                                formValue={store}
                                onChange={(value) => {
                                    setStore(value);
                                    setChange(true);
                                }}
                            >
                                <h3>Datos de la empresa</h3>
                                <div className="container">
                                    {/* 1st row */}
                                    <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                                        <TextField className = 'col' name="name" label="Nombre"/>
                                        <TextField className = 'col' name="rubro" label="Rubro"/>
                                        <TextField className = 'col' name="cuit" label="CUIT" style={disableInput} readOnly={true}/>
                                        <TextField className = 'col' name="telephone" label="Teléfono" />
                                        <TextField className = 'col' name="email" label="Email" />
                                        <TextField className = 'col' name="province" label="Provincia" />
                                        <TextField className = 'col' name="county" label="Localidad" />
                                        <TextField className = 'col' name="addressStreet" label="Dirección" />
                                        <TextField className = 'col' name="addressNumber" label="Número" />
                                        <TextField className = 'col' name="postalCode" label="Código postal" />
                                    </div>
                                </div>
                                <FormGroup />
                                <FormGroup>
                                    <ControlLabel>Cargar archivos</ControlLabel>
                                    <Uploader
                                        multiple
                                        disabled={isLoading || uploadDisabled}
                                        fileList={store.filesList}
                                        autoUpload={false}
                                        onRemove={file => handleRemove(file)}
                                        onChange={files => handleChange(files)}
                                        onPreview={file => handleDownload(file)}
                                    >
                                        <div style={{ lineHeight: 4 }}>Haga Click para cargar sus archivos</div>
                                    </Uploader>
                                </FormGroup>
                            </Form>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div className='d-flex justify-content-end'>
                    <div>
                        <Button appearance='primary' disabled={isLoading} onClick={handleUpDateCommerce} >{!change ? 'Aceptar' : 'Guardar'}</Button>
                        <Button disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>

    );
};
